<template>
  <Button
    class="link test-send"
    :disabled="sendingTest || loading"
    title="Send a preview 📩"
    @click="onTestSendClick"
  >
    <span class="label" :class="{ toggle: iconPosition === 'left' }">
      {{ sendingTest ? "Sending..." : "Send Test" }}
    </span>
    <v-icon
      v-if="!sendingTest"
      slot="icon-start"
      name="paper-plane"
      :scale="iconScale"
      class="test-send-icon"
    />
    <v-icon
      v-else
      slot="icon-start"
      name="spinner"
      class="test-sending-icon"
      spin
    />
  </Button>
</template>

<script>
export default {
  name: "TestSend",

  props: {
    loading: Boolean,
    sendingTest: Boolean,
    iconPosition: {
      type: String,
      default: "right",
    },
    iconScale: {
      type: Number,
      default: 0.8,
    },
  },
  methods: {
    onTestSendClick() {
      this.$emit("test-send");

      this.$gtm.trackEvent({
        event: "promo-test-send",
        campaignId: this.$route.params.id,
      });
    },
  },
};
</script>

<style scoped>
.test-send {
  @apply flex items-center px-0;

  &[disabled],
  &:hover[disabled] {
    @apply no-underline opacity-50;
  }
}

.label {
  @apply ml-1;

  &.toggle {
    order: 1;
  }

  @screen sm {
    @apply text-xs;
  }

  @screen md {
    @apply text-sm;
  }

  @screen lg {
    @apply text-base;
  }
}

.test-send-icon {
  @apply align-middle;
  order: 0;
}

.test-sending-icon {
  @apply p-0 relative inline-block;
  color: currentColor;
  font-size: 12px;
  top: 1px;
}
</style>
